<template>
  <div class="detail">
    <div class="top_box">
      <div class="header">
        <div class="left" @click="toIndex()">< 返回</div>
        <div class="span1">添加材料</div>
        <div class="right"></div>
      </div>
      <div class="Homeboxtop_nav_tab">
        <span
          style="padding-bottom: 20px"
          v-for="(item, index) in tabList"
          :class="['res-tab', { active: item.name === tabName }]"
          :key="index"
          @click="tabClick(item)"
        >
          {{ item.name }}
        </span>
      </div>
    </div>
    <div class="main" v-show="tabName === '填写基本信息'">
      <el-form :inline="false" label-width="125px">
        <el-form-item label="材料名称" :required="true">
          <el-input
            v-model="addData.mname.value"
            placeholder="请输入"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="材料图片" :required="true">
          <div class="material-upload">
            <div class="uploadBtnMore" style="margin-top: 5px">
              <label for="upload_cl">
                <span size="medium" round class="temp">上传图片</span>
                <input
                  style="display: none"
                  type="file"
                  accept="image/*"
                  :disabled="addData.cl.canClick"
                  id="upload_cl"
                  name="upload_cl"
                  multiple
                  ref="ipt_cl"
                  @change="uploadFile_cl"
                />
              </label>
            </div>
            <div class="m-l upload-text" style="line-height: 36px">
              允许上传图片的格式为jpg、jpeg、gif、bmp、png<br />
              最多可上传2张
            </div>
            <ul class="m-t upload-files">
              <li v-for="(item, i) in addData.cl.value" :key="i + item.fid">
                <img :src="item.previewUrl" alt="" class="img" />
                <img
                  src="./imgs/del.svg"
                  alt=""
                  class="del"
                  v-if="item.previewUrl"
                  @click="delFile(addData.cl.value, i)"
                />
              </li>
            </ul>
          </div>
        </el-form-item>
        <el-form-item label="学科类型" :required="true">
          <el-radio-group v-model="addData.xk_type.value">
            <el-radio :label="'0'">学科类</el-radio>
            <el-radio :label="'1'">非学科类</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="材料价格" :required="true">
          <el-input
            v-model="addData.jg.value"
            placeholder="请输入"
            style="width: 235px"
            @input="addData.jg.value = clearNoNumTwo(addData.jg.value)"
          ></el-input>
          <span style="margin-left: 10px">元</span>
        </el-form-item>
        <el-form-item label="材料描述" :required="true">
          <el-input
            v-model="addData.ms.value"
            type="textarea"
            resize="none"
            :rows="5"
            placeholder="请输入"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="材料使用期限" :required="true">
          <el-date-picker
            v-model="addData.date.value"
            type="daterange"
            style="width: 240px"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <footer>
        <el-button
          style="width: 120px"
          type="primary"
          size=""
          @click="tabName = '填写材料信息'"
          >下一步</el-button
        >
      </footer>
    </div>

    <div class="main" v-show="tabName === '填写材料信息'">
      <el-form :inline="false" label-width="125px">
        <el-form-item label="材料类型" :required="true">
          <el-radio-group v-model="addData.m_type.value">
            <el-radio :label="'0'">线上材料</el-radio>
            <el-radio :label="'1'">线下材料</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 线上材料 -->
        <template v-if="addData.m_type.value == '0'">
          <el-form-item label="下载网站" :required="true">
            <el-input
              v-model="data1.wz.value"
              maxlength="100"
              show-word-limit
              type="text"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="开发者" :required="true">
            <el-input
              v-model="data1.kfz.value"
              maxlength="100"
              show-word-limit
              type="text"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="资源主题" :required="true">
            <el-input
              v-model="data1.zt.value"
              maxlength="100"
              show-word-limit
              type="text"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="资源简介" :required="true">
            <el-input
              v-model="data1.jj.value"
              type="textarea"
              resize="none"
              maxlength="200"
              show-word-limit
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="适用对象" :required="true">
            <el-input
              v-model="data1.dx.value"
              maxlength="100"
              show-word-limit
              type="text"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="图文来源" :required="true">
            <el-input
              v-model="data1.ly.value"
              maxlength="100"
              show-word-limit
              type="text"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </template>
        <!-- 线下材料 -->
        <template v-if="addData.m_type.value == '1'">
          <el-form-item label="编写者" :required="true">
            <el-input
              v-model="data2.bxz.value"
              type="text"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="材料简介" :required="true">
            <el-input
              v-model="data2.jj.value"
              type="text"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="材料内容" :required="true">
            <el-input
              v-model="data2.nr.value"
              type="text"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="适用对象" :required="true">
            <el-input
              v-model="data2.dx.value"
              type="text"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </template>
      </el-form>
      <footer>
        <el-button style="width: 120px" size="" @click="toIndex()"
          >取消</el-button
        >
        <el-button
          style="margin-left: 20px; width: 120px"
          type="primary"
          size=""
          @click="save()"
          >保存</el-button
        >
      </footer>
    </div>
  </div>
</template>
<script>
import {
  handleMaterialsUpdate,
  handleMaterialsAdd,
} from "@/api/mechanismApi/curriculum.js";
import util from "@/utils/util.js";
import _ from "lodash";
import UploadService from "@/utils/fileCenter/tencentCloud.upload";
import dayjs from "dayjs";
export default {
  props: ["info"],
  components: {},
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      addData: {
        mname: { value: "", title: "材料名称" },
        cl: { value: [], title: "材料图片", canClick: false },
        xk_type: { value: "0", title: "学科类型" },
        jg: { value: "", title: "材料价格" },
        ms: { value: "", title: "材料描述" },
        date: { value: "", title: "材料使用期限" },
        m_type: { value: "0", title: "材料类型" },
      },
      data1: {
        wz: { value: "", title: "下载网站" },
        kfz: { value: "", title: "开发者" },
        zt: { value: "", title: "资源主题" },
        jj: { value: "", title: "资源简介" },
        dx: { value: "", title: "适用对象" },
        ly: { value: "", title: "图文来源" },
      },
      data2: {
        bxz: { value: "", title: "编写者" },
        jj: { value: "", title: "材料简介" },
        nr: { value: "", title: "材料内容" },
        dx: { value: "", title: "适用对象" },
      },
      tabList: [{ name: "填写基本信息" }, { name: "填写材料信息" }],
      tabName: "填写基本信息",
      canClick: false,
      uploadInstance: null,
      userInfo: JSON.parse(window.sessionStorage.getItem("Userlist")) || {},
    };
  },
  computed: {},
  watch: {
    "info.mid": function (n, o) {
      if (n) {
        let vm = this.addData,
          obj = this.info;
        vm.mname.value = obj.mname; // 材料名称
        vm.jg.value = obj.price; // 材料价格
        vm.xk_type.value = obj.subjectType; // 学科类型
        vm.ms.value = obj.describe; // 材料描述
        vm.date.value = obj.useStartEndTime.split(" ~ "); // 使用开始时间
        vm.m_type.value = obj.classify; // 材料类型
        vm.cl.value = obj.resource.filter((e) => e.source == "0"); // 材料图片
        if (vm.m_type.value == "0") {
          this.data1.wz.value = obj.downloadSite; // 下载网站
          this.data1.kfz.value = obj.developerInfo; // 开发者
          this.data1.zt.value = obj.resourcesTheme; // 资源主题
          this.data1.jj.value = obj.resourceProfile; // 资源简介
          this.data1.dx.value = obj.suitableObject; // 适用对象
          this.data1.ly.value = obj.graphicSource; // 图文来源
        } else {
          this.data2.bxz.value = obj.authorInfo; // 编写者
          this.data2.jj.value = obj.synopsis; // 材料简介
          this.data2.nr.value = obj.content; // 材料内容
          this.data2.dx.value = obj.suitableObject; // 适用对象
        }
      } else {
        this.init();
      }
    },
  },
  created() {},
  methods: {
    // 处理输入框小数点两位问题
    clearNoNumTwo(obj) {
      obj = obj.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
      obj = obj.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      obj = obj.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
      if (obj.indexOf(".") < 0 && obj != "") {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        obj = parseFloat(obj);
      }
      let strObj = obj.toString();
      if (strObj.indexOf(".") > -1 && strObj === "0.00") {
        obj = parseFloat(obj).toFixed(1);
      }
      return obj;
    },
    delFile(arr, i) {
      arr.splice(i, 1);
    },
    delTr(i, type) {
      if (type === "one") {
        this.addData.file_1.value.splice(i, 1);
      } else {
        this.addData.file_2.value.splice(i, 1);
      }
    },
    // 上传材料图片
    async uploadFile_cl(e) {
      this.uploadInstance = new UploadService({
        appType: "khfw",
        userInfo: {
          userId: JSON.parse(window.sessionStorage.getItem("Userlist")).userId,
          platformCode: JSON.parse(window.sessionStorage.getItem("Userlist"))
            .platformCode,
        },
      });
      const sourceFiles = this.$refs.ipt_cl.files;
      if (sourceFiles.length + this.addData.cl.value.length > 2) {
        this.$message.error("最多上传2张图片");
        return false;
      }
      this.addData.cl.canClick = true;
      try {
        let promiseList = [];
        for (let i = 0; i < sourceFiles.length; i++) {
          let ext = util.getFileExt(sourceFiles[i]["name"]);
          if (sourceFiles[i]["size"] == 0) {
            //大小为0的文件
            this.$message({
              message: `文件${sourceFiles[i]["name"]}是空文件,自动过滤删除`,
              type: "error",
              duration: 1000,
            });
            continue;
          }
          this.addData.cl.value.push({
            name: sourceFiles[i]["name"],
            size: this.formatFileSize(sourceFiles[i].size),
            fileLength: sourceFiles[i].size,
            type: this.getExt(ext),
            ext: ext,
            source: "0",
          });
          const fn = this.uploadInstance.upload(sourceFiles[i], {
            onProgress: (progress) => {},
          });
          promiseList.push(fn);
        }
        const resArr = await Promise.all(promiseList);
        const markIdx = this.addData.cl.value.length - resArr.length;
        console.log(resArr, "itemResitemRes");
        resArr.forEach((res, index) => {
          const itemRes = res.data;
          this.addData.cl.value[markIdx + index].fid = itemRes.fid;
          this.addData.cl.value[markIdx + index].downloadUrl =
            itemRes.downloadUrl;
          if (itemRes.previewUrl) {
            this.addData.cl.value[markIdx + index].previewUrl =
              itemRes.previewUrl;
          } else {
            this.addData.cl.value[markIdx + index].previewUrl =
              itemRes.downloadUrl;
          }
        });
      } catch (error) {
        this.$message({
          message: "上传失败",
          type: "error",
          duration: 1000,
        });
        console.log(error);
      } finally {
        this.addData.cl.canClick = false;
        e.target.value = "";
      }
    },
    previewFile(item) {
      window.open(item.previewUrl);
    },
    tabClick(item) {
      this.tabName = item.name;
    },
    toIndex() {
      this.$emit("to-index");
    },
    save: _.throttle(
     async function () {
             let vm = this.addData;
      if (!util.checkData(vm)) {
        return false;
      }
      if (vm.m_type.value == "0") {
        if (!util.checkData(this.data1)) {
          return false;
        }
      } else {
        if (!util.checkData(this.data2)) {
          return false;
        }
      }
      let file_arr = [...vm.cl.value];
      let useTime =
        dayjs(vm.date[0]).format("YYYY-MM-DD") +
        " ~ " +
        dayjs(vm.date[1]).format("YYYY-MM-DD");
      let params = {
        coverUrl: vm.cl.value[0].previewUrl, // 材料封面
        mname: vm.mname.value, // 材料名称
        price: vm.jg.value, // 材料价格
        subjectType: vm.xk_type.value, // 学科类型
        describe: vm.ms.value, // 材料描述
        useStartEndTime: useTime, // 使用开始时间
        classify: vm.m_type.value, // 材料类型
        resource: file_arr, // 材料图片
      };
      let b_data = {};
      if (vm.m_type.value == "0") {
        b_data = {
          downloadSite: this.data1.wz.value, // 下载网站
          developerInfo: this.data1.kfz.value, // 开发者
          resourcesTheme: this.data1.zt.value, // 资源主题
          resourceProfile: this.data1.jj.value, // 资源简介
          suitableObject: this.data1.dx.value, // 适用对象
          graphicSource: this.data1.ly.value, // 图文来源
          authorInfo: "", // 编写者
          synopsis: "", // 材料简介
          content: "", // 材料内容
        };
      } else {
        b_data = {
          downloadSite: "", // 下载网站
          developerInfo: "", // 开发者
          resourcesTheme: "", // 资源主题
          resourceProfile: "", // 资源简介
          graphicSource: "", // 图文来源
          authorInfo: this.data2.bxz.value, // 编写者
          synopsis: this.data2.jj.value, // 材料简介
          content: this.data2.nr.value, // 材料内容
          suitableObject: this.data2.dx.value, // 适用对象
        };
      }
      params = { ...params, ...b_data };
      console.log("材料添加", params);
      // return
      if (this.info.mid) {
        params.mid = this.info.mid;
        var res = await handleMaterialsUpdate(params);
        if (res.result === "000000") {
          this.$message.success("编辑成功");
          this.info.mid = null;
          this.init();
          this.$emit("to-init");
          this.toIndex();
        } else {
          this.$message.error("编辑失败");
        }
      } else {
        var res = await handleMaterialsAdd(params);
        if (res.result === "000000") {
          this.$message.success("创建成功");
          this.init();
          this.$emit("to-init");
          this.toIndex();
        } else {
          this.$message.error("创建失败");
        }
      }
      },
      3000,
      { leading: true, trailing: false }
    ),
    init() {
      this.addData = {
        mname: { value: "", title: "材料名称" },
        cl: { value: [], title: "材料图片", canClick: false },
        xk_type: { value: "0", title: "学科类型" },
        jg: { value: "", title: "材料价格" },
        ms: { value: "", title: "材料描述" },
        date: { value: "", title: "材料使用期限" },
        m_type: { value: "0", title: "材料类型" },
      };
      this.data1 = {
        wz: { value: "", title: "下载网站" },
        kfz: { value: "", title: "开发者" },
        zt: { value: "", title: "资源主题" },
        jj: { value: "", title: "资源简介" },
        dx: { value: "", title: "适用对象" },
        ly: { value: "", title: "图文来源" },
      };
      this.data2 = {
        bxz: { value: "", title: "编写者" },
        jj: { value: "", title: "材料简介" },
        nr: { value: "", title: "材料内容" },
        dx: { value: "", title: "适用对象" },
      };
      this.tabName = "填写基本信息";
    },
    getExt(ext) {
      return util.getFileType(ext);
    },
    formatFileSize(limit) {
      limit = limit * 1;
      let size = "";
      if (limit < 0.1 * 1024) {
        // 小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B";
      } else if (limit < 0.1 * 1024 * 1024) {
        // 小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + "KB";
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {
        // 小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB";
      } else {
        // 其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      }
      let sizeStr = size + ""; // 转成字符串
      let index = sizeStr.indexOf("."); // 获取小数点处的索引
      let dou = sizeStr.substr(index + 1, 2); // 获取小数点后两位的值
      if (dou === "00") {
        // 判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
      }
      return size;
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  .top_box {
    width: 100%;
    height: 130px;
    padding: 0px 30px;
  }
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }
  .main {
    padding: 20px;
    position: absolute;
    width: 100%;
    height: calc(100% - 130px);
    overflow: auto;
    .main-title {
      display: flex;
      align-items: center;
      p {
        font-weight: bold;
        font-size: 14px;
        color: #181c26;
        margin-left: 10px;
      }
    }
    .input-list {
      display: flex;
      align-items: flex-start;
      margin-top: 10px;
      p {
        width: 90px;
        line-height: 21px;
        font-size: 14px;
        color: #606266;
      }
    }
    .check-title {
      display: inline-block;
      width: 60px;
      color: #606266;
      font-size: 14px;
      padding-left: 3px;
    }
  }
  footer {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
}

.material-upload {
  .uploadBtnMore {
    width: 80px;
    height: 28px;
    font-size: 13px;
    text-align: center;
    line-height: 28px;
    color: #009dfd;
    border-radius: 15px;
    border: 1px solid #009dfd;
    cursor: pointer;
    display: inline-block;
    float: left;
    span {
      cursor: pointer;
      display: block;
    }
  }
  .upload-text {
    line-height: 24px;
    color: #999;
    margin-left: 102px;
  }
  .upload-files {
    li {
      display: inline-block;
      position: relative;
      height: 100px;
      width: 150px;
      margin-right: 10px;
      .img {
        max-width: 150px;
      }
      .del {
        position: absolute;
        top: -12px;
        right: -15px;
        cursor: pointer;
        transition: 0s background-color;
      }
    }
  }
}
.course-box {
  display: flex;
  margin-bottom: 10px;
  p {
    width: 60px;
    color: #999;
  }
}
</style>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
} /* chrome */
input[type="number"] {
  -moz-appearance: textfield; /* firefox */
}
</style>
